var _module_exports = "<div class=\"sparkline-dygraph-target\" style=\"height:100%;width:100%\">\n</div>\n\n";;
var path = '/builds/observability/imm/signalview/src/app/charting/chartdisplay/sparkline/sparkline.tpl.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;